module.exports = __webpack_public_path__ + "static/img/home-img3.7078fba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img3.png
// module id = xWvX
// module chunks = 1